/*
 * @Description: 自然人
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { accountManagement } from '@/api/ajax';
import fields from '../fields';
import search from '../search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import RoleManagement from '../../child/roleManagement.vue';
import AccountAction from '../../child/accountAction.vue';

let roleManagement = {
  name: '角色管理',
  icon: '',
  type: 'primary',
  fn(app, table) {
    table.$xrkDialog({
      title: '角色管理',
      width: '65%',
      showCancel: true,
      cancelText:'关闭',
      showConfirm: false,
      $slots: {
        default: table.$createElement(RoleManagement)
      }
    });
  }
};

let newAccount = {
  name: '新增账号',
  icon: '',
  type: 'warning',
  fn(app, table) {
    table.$xrkDialog({
      title: '新增账号',
      width: '80%',
      showCancel: false,
      showConfirm: false,
      $slots: {
        default: table.$createElement(AccountAction, {
          props: { actionType: 1, userId: '-1' },
          on: {
            confirm: () => {
              table.reGetPage();
            }
          }
        })
      }
    });
  }
};

let example = new TableRenderClass({ fields, search });
let part = example.createPart({
  name: '子账号管理',
  search: [
    'userName',
    'fullName',
    'phone',
    'department',
    'roleId',
    'position',
    'createDt'
  ],
  list: accountManagement.subaccountManagementList,
  defaultQueryHotfix: { type: 1 },
  fields: [
    'index',
    'subAccountName',
    'createDt',
    'roleName',
    'fullName',
    'phone',
    'department',
    'position',
    'auth',
    'status',
    'operate'
  ],
  moreBtnArr: [roleManagement, newAccount]
});

export default part;
